<script lang="ts">
  import { getToasts, dismissToast } from '$shared/toasts.svelte';

  const toasts = $derived(getToasts());
</script>

{#if toasts.length > 0}
  <div class="toast-container">
    {#each toasts as toast (toast.id)}
      <div
        class="toast toast--{toast.variant}"
        class:toast--dismissing={toast.dismissing}
        role="status"
        aria-live="polite"
      >
        <span class="toast__text">{toast.message}</span>
        <button class="toast__close" onclick={() => dismissToast(toast.id)} aria-label="Dismiss">&times;</button>
      </div>
    {/each}
  </div>
{/if}

<style>
  .toast-container {
    position: fixed;
    bottom: 1.5rem;
    right: 1.5rem;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    max-width: 22rem;
  }

  .toast {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    background: var(--surface);
    border: 1px solid var(--border);
    border-left: 3px solid var(--cyan);
    border-radius: var(--radius);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
    opacity: 1;
    transform: translateY(0);
    transition:
      opacity 0.3s ease,
      transform 0.3s ease;
  }

  .toast--submit {
    border-left-color: var(--pink);
  }
  .toast--join {
    border-left-color: var(--cyan);
  }
  .toast--follow {
    border-left-color: var(--green);
  }
  .toast--points {
    border-left-color: var(--purple);
  }
  .toast--error {
    border-left-color: var(--error);
  }

  .toast--dismissing {
    opacity: 0;
    transform: translateY(12px);
  }

  .toast__text {
    flex: 1;
    font-size: 0.875rem;
    color: var(--text);
  }

  .toast__close {
    background: none;
    border: none;
    color: var(--text-muted);
    font-size: 1.125rem;
    cursor: pointer;
    padding: 0;
    line-height: 1;
  }
  .toast__close:hover {
    color: var(--text);
  }
</style>
